import { mapState, mapGetters, mapActions } from "vuex";
import parseJwt from "@/util/parseJwt";
import { getCookie } from "@/util/cookies";

export default {
  data: () => ({
    employeeId: "",
    password: "",
    otpCode: "",
    erMsg: "",
    hidePassword: true,
    fileAbsentRoute: "",
    expiredTime: 600,
  }),
  computed: {
    ...mapState("auth", ["dataLoginSuccess", "dataLoginFailed", "isLoading"]),
    ...mapGetters("auth", [
      "SUPERADMIN",
      "MANAGER",
      "MEMBER",
      "TEAMLEADER",
      "INTERNSHIP",
    ]),
    newExpTime() {
      const minute = Math.floor(this.expiredTime / 60);
      const second = this.expiredTime % 60;
      const newMinute =
        minute.toString().length === 1 ? `0${minute}` : `${minute}`;
      const newSecond =
        second.toString().length === 1 ? `0${second}` : `${second}`;
      return `${newMinute} : ${newSecond}`;
    },
  },
  methods: {
    ...mapActions("auth", ["callLogin"]),
    toggleHidePassword() {
      this.hidePassword = !this.hidePassword;
    },
    async Login() {
      if (this.$route.params.otp === "otp") {
        const request = {
          employeeId: this.employeeId,
          otp: this.otpCode,
        };
        const res = await this.callLogin(request);
        if (res) {
          if (this.SUPERADMIN) {
            if (this.fileAbsentRoute.name === "FileAbsent") {
              this.$router.push(this.fileAbsentRoute);
              this.fileAbsentRoute = "";
            } else {
              this.$router.push("/");
            }
          } else if (this.MANAGER) {
            if (this.fileAbsentRoute.name === "FileAbsent") {
              this.$router.push(this.fileAbsentRoute);
              this.fileAbsentRoute = "";
            } else {
              this.$router.push("/manager");
            }
          } else if (this.MEMBER) {
            this.$router.push("/member");
          } else if (this.TEAMLEADER) {
            this.$router.push("/teamleader");
          } else if (this.INTERNSHIP) {
            this.$router.push("/member");
          }
          this.$notify({
            message: "Login Success",
            timeout: 1000,
            icon: "ni ni-bell-55",
            type: "success",
          });
        } else {
          this.$notify({
            message: this.dataLoginFailed,
            timeout: 5000,
            icon: "ni ni-bell-55",
            type: "danger",
          });
        }
      } else {
        const request = {
          employeeId: this.employeeId,
          password: this.password,
        };
        const res = await this.callLogin(request);
        if (res) {
          if (this.SUPERADMIN) {
            if (this.fileAbsentRoute.name === "FileAbsent") {
              this.$router.push(this.fileAbsentRoute);
              this.fileAbsentRoute = "";
            } else {
              // this.$router.push("/");
              this.$router.push({ name: "Portal" });
            }
          } else if (this.MANAGER) {
            if (this.fileAbsentRoute.name === "FileAbsent") {
              this.$router.push(this.fileAbsentRoute);
              this.fileAbsentRoute = "";
            } else {
              // this.$router.push("/manager");
              this.$router.push({ name: "Portal" });
            }
          } else if (this.MEMBER) {
            // this.$router.push("/member");
            this.$router.push({ name: "Portal" });
          } else if (this.TEAMLEADER) {
            // this.$router.push("/teamleader");
            this.$router.push({ name: "Portal" });
          } else if (this.INTERNSHIP) {
            // this.$router.push("/member");
            this.$router.push({ name: "Portal" });
          }
          this.$notify({
            message: "Login Success",
            timeout: 3000,
            icon: "ni ni-bell-55",
            type: "success",
          });
        } else {
          this.$notify({
            message: this.dataLoginFailed,
            timeout: 5000,
            icon: "ni ni-bell-55",
            type: "danger",
          });
        }
      }
    },
    redirecTo() {
      const token = getCookie("token");
      if (token) {
        this.$router.push({ name: 'Portal' })
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fileAbsentRoute = from;
    });
  },
  mounted() {
    if (this.$route.params.otp === "otp") {
      const timeExp = setInterval(() => {
        this.expiredTime -= 1;
        if (this.expiredTime === 0) {
          this.$router.replace("/auth");
          this.$notify({
            message: "Sesi Habis, Ulangi lagi",
            timeout: 3000,
            icon: "ni ni-bell-55",
            type: "warning",
          });
          clearInterval(timeExp);
        }
      }, 1000);
    }
  },
  created() {
    this.redirecTo();
  },
};
